<template>
  <div>
    <v-card color="transparent" flat class="likert">
      <v-card-title class="font-weight-bold q-message">
        <p style="line-height: 40px">
          {{ `${qNumber}.` }}
          <v-chip v-if="subCategory !== ''" class="ml-5" color="#fab26c" dark label>{{ subCategory }}</v-chip>
          <br v-if="subCategory !== ''" />
          {{ `${qMessage.split(/:/)[0]}` }}
          <br />
          <span class="text-h6 font-italic" v-if="qMessage.indexOf(':') > -1">{{ `${qMessage.split(/:/)[1]}` }}</span>
        </p>
      </v-card-title>
      <v-item-group class="mb-12" mandatory :value="selected">
        <v-container class="pl-10 mb-12">
          <v-row class="justify-space-between" dense>
            <v-col v-for="n in 10" :key="n" cols="1">
              <v-item v-slot:default="{ active, toggle }">
                <v-card :color="active ? 'secondary' : '#cfecf4'" class="d-flex align-center white--text" height="60" flat @click="confirm(n, toggle)">
                  <div v-if="!active" class="display-1 flex-grow-1 text-center font-weight-bold">
                    <span>{{ n }}</span>
                  </div>
                  <v-scroll-y-transition>
                    <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)" v-if="active" class="display-1 flex-grow-1 text-center font-weight-bold">{{ n }}</div>
                  </v-scroll-y-transition>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
          <v-row class="justify-space-between" dense>
            <template v-if="answerList.length === 0">
              <v-col cols="2" class="text-left">
                <span>매우 그렇지 않다</span>
              </v-col>
              <v-col cols="2" class="text-right">
                <span>매우 그렇다</span>
              </v-col>
            </template>
            <template v-else>
              <v-col v-for="n in 10" :key="'a' + n" cols="1" class="text-center">
                <span>{{ answerList.filter((a) => a.score === n).length === 1 ? answerList.filter((a) => a.score === n)[0].message : '' }}</span>
              </v-col>
            </template>
          </v-row>
        </v-container>
      </v-item-group>
      <div class="mt-12"></div>
    </v-card>
    <v-card-actions>
      <!-- <v-btn color="#70cae9" :disabled="!selected" width="100" class="headline white--text" @click="confirm">
        확인
        <v-icon right>mdi-check</v-icon>
      </v-btn> -->
    </v-card-actions>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
export default {
  props: {
    qCategory: { type: String, default: '' },
    qId: {
      type: String,
      default: '',
    },
    qNumber: {
      type: String,
      default: '',
    },
    qMessage: {
      type: String,
      default: '',
    },
    subMessage: {
      type: String,
      default: '',
    },
    qTitle: {
      type: String,
      default: '',
    },
    subCategory: {
      type: String,
      default: '',
    },
    answerList: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    const ans = (this[this.qCategory.toLowerCase()] || {})[this.qId]
    if (ans) {
      this.isCompleted = true
      this.value = ans.value
      this.selected = ans.value - 1
    }
  },
  data() {
    return {
      selected: undefined,
      value: undefined,
      isCompleted: false,
    }
  },
  methods: {
    ...mapMutations(['setMaster']),
    ...mapActions(['submit']),

    confirm(val, toggle) {
      toggle()
      console.log('==>', val)
      this.selected = val - 1

      this.$emit('nextSlide')
      const payload = {
        id: this.qId,
        question: this.qMessage,
        subCategory: this.subCategory,
        value: val,
        summary: this.subMessage,
      }
      this.setMaster(payload)
      this.submit()
    },
  },
  computed: {
    ...mapState(['master', 'me', 'wife', 'children', 'parents', 'finance', 'currentYear', 'housePension', 'career', 'action']),
  },
}
</script>

<style scoped>
div.likert {
  height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.subCategory {
  color: #fab26c;
}
</style>
